/**
 * List of possible error codes which is can be returned by server side
 */

export const RESPONSE_ERROR = {
  USER_EXISTS: 'userAlreadyExists',
  PHONE_IS_USED: 'phoneIsUsed',
};
